/**
 * Deze klasse handelt het aanpassen van audio af
 *
 * @history
 * 11 augustus 2023
 *
 * 10 augustus 2023
 * met audio opname (geen upload meer)
 *
 * 26 juli 2023
 * Start implementatie
 *
 */

import React from "react";
import {Popup} from "../../containers/Popup";

export class LogAudioForm extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state =
            {
                show_err: false,
                err_message: "",
                show_start_record: true,
                show_stop_record:false,
                audio_kind:"",
            }


        this.inputTitle = React.createRef();
        this.inputText = React.createRef();

        this.storeClicked = this.storeClicked.bind(this);
        this.terugClicked = this.terugClicked.bind(this);
        this.inputAudioBtn = React.createRef();
        this.audioPreview = React.createRef();
        this.audioSelectClicked = this.audioSelectClicked.bind(this);
        this.audioSelected = this.audioSelected.bind(this);

        this.audioVisualizer = React.createRef();
        this.recordStartClicked = this.recordStartClicked.bind(this);
        this.recordStopClicked = this.recordStopClicked.bind(this);
        this.mediaRecorder = null;
        this.audioCtx = false;
        this.canvasCtx = false;
        this.animationId = false;

        this.audio_data = "";

        this.formData = new FormData();

        this.formData.append("group_id", this.props.group_id);
        this.formData.append("access_id1", window.app.logboek.access_id1);
        this.formData.append("access_id2", window.app.logboek.access_id2);
        this.formData.append("kind", "audio");
        this.formData.append("location_id", this.props.location_id);

        if (this.props.action == "add")
        {
            this.form_url = "/add_log";
            this.props.log.title = "";
            this.props.log.data = "";
        } else
        {
            this.form_url = "/store_log";
            this.formData.append("id", this.props.log.id);
        }

    }

    audioSelectClicked()
    {
        this.inputAudioBtn.current.click();
    }

    audioSelected(event)
    {

        const fileObj = event.target.files && event.target.files[0];
        if (!fileObj)
        {
            console.log("no file")
            return;
        }


        var reader = new FileReader();
        const _this = this;
        reader.onload = function (e)
        {
            _this.audioPreview.current.src = e.target.result;
            _this.audio_data = e.target.result.split(',')[1];
            _this.audioPreview.current.style.display = 'block';
            _this.setState({ "audio_kind":"mp3"});
        };
        reader.readAsDataURL(fileObj);
    }

    visualize(stream) {
        if(!this.audioCtx) {
            this.audioCtx = new AudioContext();
        }

        const source = this.audioCtx.createMediaStreamSource(stream);

        const analyser = this.audioCtx.createAnalyser();
        analyser.fftSize = 2048;
        const bufferLength = analyser.frequencyBinCount;
        const dataArray = new Uint8Array(bufferLength);

        source.connect(analyser);
        //analyser.connect(audioCtx.destination);

        const _this = this;

        draw()

        function draw() {
            const WIDTH = _this.audioVisualizer.current.width
            const HEIGHT = _this.audioVisualizer.current.height;

            _this.animationId = requestAnimationFrame(draw);

            analyser.getByteTimeDomainData(dataArray);

            _this.canvasCtx.fillStyle = 'rgb(200, 200, 200)';
            _this.canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);

            _this.canvasCtx.lineWidth = 2;
            _this.canvasCtx.strokeStyle = 'rgb(0, 0, 0)';

            _this.canvasCtx.beginPath();

            let sliceWidth = WIDTH * 1.0 / bufferLength;
            let x = 0;


            for(let i = 0; i < bufferLength; i++) {

                let v = dataArray[i] / 128.0;
                let y = v * HEIGHT/2;

                if(i === 0) {
                    _this.canvasCtx.moveTo(x, y);
                } else {
                    _this.canvasCtx.lineTo(x, y);
                }

                x += sliceWidth;
            }

            _this.canvasCtx.lineTo(_this.audioVisualizer.current.width, _this.audioVisualizer.current.height/2);
            _this.canvasCtx.stroke();

        }
    }


    recordStartClicked()
    {
        this.setState({
            show_start_record: false,
            show_stop_record:true
        });

        this.audioCtx = false;
        this.canvasCtx = this.audioVisualizer.current.getContext("2d");

        const _this = this;
        navigator.mediaDevices.getUserMedia({ audio: true }).then(function(stream)
            {
                let chunks = [];
                _this.mediaRecorder = new MediaRecorder(stream);

                _this.visualize(stream);
                _this.mediaRecorder.onstop = function(e) {
                    console.log("data available after MediaRecorder.stop() called.");

                    let audio_type = 'audio/webm;codecs=opus';
                    if (_this.mediaRecorder.mimeType != "" && _this.mediaRecorder.mimeType != audio_type)
                    {
                        audio_type = "audio/mp4";
                        _this.setState({ "audio_kind":"mp4"});
                    }
                    else
                    {
                        _this.setState({ "audio_kind":"webm"});
                    }


                    const blob = new Blob(chunks, { 'type' : audio_type });
                    chunks = [];
                    _this.audioPreview.current.src = window.URL.createObjectURL(blob);
                    var reader = new FileReader();

                    reader.onloadend = function ()
                    {

                        _this.audio_data = reader.result.split(',')[1];
                        _this.audioPreview.current.style.display = 'block';
                        if (_this.animationId)
                        {
                            cancelAnimationFrame(_this.animationId);
                            _this.canvasCtx.fillStyle = 'rgb(255, 255, 255)';
                            _this.canvasCtx.fillRect(0, 0, _this.audioVisualizer.current.width, _this.audioVisualizer.current.height);
                        }
                        _this.animationId = false;
                    };
                    reader.readAsDataURL(blob);
                    console.log("recorder stopped");
                }

                _this.mediaRecorder.ondataavailable = function(e) {
                    chunks.push(e.data);
                }

                _this.mediaRecorder.start();
            },
            function(err) {
                console.log('The following error occured: ' + err);
            });
    }

    recordStopClicked()
    {
        this.mediaRecorder.stop();
        this.setState({
            show_start_record: true,
            show_stop_record:false
        })
    }

    terugClicked()
    {
        this.props.edit_done_callback(false);
    }

    storeClicked()
    {
        if (this.audio_data == "" && this.props.action == "add")
        {
            this.setState({"show_err": true, "err_message": "Geen audio geselecteerd. Probeer het opnieuw"});
            return false;
        }

        this.setState({"show_err": false});


        this.setState({"show_err": false});
        this.formData.append("title", this.inputTitle.current.value);
        this.formData.append("text", this.inputText.current.value);
        this.formData.append("audio_kind", this.state.audio_kind);

        if (this.audio_data != "")
        {
            this.formData.append("audio", this.audio_data);
        }


        const requestOptions = {
            method: 'POST',
            body: this.formData
        };

        fetch(this.form_url, requestOptions)
            .then(response => response.json())
            .then(log_json =>
            {
                if (log_json.status == "err")
                {
                    this.setState({"show_err": true, "err_message": "opslaan niet gelukt. Probeer het opnieuw"});

                } else
                {
                    this.setState({'login_err': false});
                    this.props.edit_done_callback(true, log_json.data);
                }
            });
    }


    render()
    {
        return (
            <Popup>

                <h2>Titel</h2>
                <input type={"text"} className={"logger__input"} name={"title"} ref={this.inputTitle} defaultValue={this.props.log.title}/><br/>
                <input type="file" accept="audio/mpeg;" id="upload_audio" name={"audio"} ref={this.inputAudioBtn} style={{"display": "none"}} onChange={this.audioSelected}/>

                {(this.props.action == "add") && (
                    <>
                        <audio controls style={{"display": "none"}} ref={this.audioPreview}></audio>



                        <canvas style={{"width":"100%","height":"60px"}} ref={this.audioVisualizer} />
                        <a href="javascript:void(0);" onClick={this.audioSelectClicked} className={"button"} id="upload_audio_btn">Upload audio [mp3]</a>
                        {this.state.show_start_record && (<a href="javascript:void(0);" onClick={this.recordStartClicked} className={"button"} >Opname starten</a>)}
                        {this.state.show_stop_record && (<a href="javascript:void(0);" onClick={this.recordStopClicked} className={"button"} >Opname stoppen</a>)}

                    </>
                )}
                {(this.props.action == "edit") && (
                    <>
                        <audio controls ref={this.audioPreview} src={this.props.log.audio_url}></audio>


                        <canvas style={{"width":"100%","height":"60px"}} ref={this.audioVisualizer} />
                        <a href="javascript:void(0);" onClick={this.audioSelectClicked} className={"button"} id="upload_audio_btn">Vervang audio [mp3]</a>
                        {this.state.show_start_record && (<a href="javascript:void(0);" onClick={this.recordStartClicked} className={"button"} >Opname starten</a>)}
                        {this.state.show_stop_record && (<a href="javascript:void(0);" onClick={this.recordStopClicked} className={"button"} >Opname stoppen</a>)}
                    </>
                )}


                <br clear="all"/>


                <h2>Beschrijving</h2>
                <textarea className={"logger__textarea"} name={"description"} ref={this.inputText}>{this.props.log.data}</textarea><br/>
                <a href="javascript:void(0)" className={"button"} onClick={this.terugClicked}>Terug</a>
                <a href="javascript:void(0)" className={"button"} onClick={this.storeClicked}>Opslaan</a>


                {this.state.show_err && (
                    <div style={{"float": "left", "width": "100%", "color": "#F00"}}>
                        <p>{this.state.err_message}</p>
                    </div>
                )}
            </Popup>

        );
    }

}
